import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class ManualDetailsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfExists: true,
      loading: true
    };
  }

  componentDidMount() {
    this.checkPdfExists();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.setState({ loading: true, pdfExists: true });
      this.checkPdfExists();
    }
  }

  checkPdfExists() {
    const { id } = this.props.match.params;
    const pdfUrl = `/manuals/${id}.pdf`;

    fetch(pdfUrl, { method: 'HEAD' })
      .then(response => {
        this.setState({
          pdfExists: response.ok,
          loading: false
        });
      })
      .catch(() => {
        this.setState({
          pdfExists: false,
          loading: false
        });
      });
  }

  render() {
    const { id } = this.props.match.params;
    const pdfUrl = `/manuals/${id}.pdf`;
    const { pdfExists, loading } = this.state;

    // Extract manual name for display
    const manualName = id.replace('Manual', '').replace('_es', ' (ES)').replace('_en', ' (EN)');

    if (loading) {
      return (
        <div>
          <div className="row mb-2">
            <div className="col-12">
              <h1 className="text-vw-dark">MANUAL</h1>
            </div>
          </div>
          <hr className="bg-vw-light" />
          <div className="text-center py-5">
            <div className="spinner"><img src="/images/logo.png" alt="Logo" /></div>
            <p className="mt-3">Cargando manual...</p>
          </div>
        </div>
      );
    }

    if (!pdfExists) {
      return (
        <div>
          <div className="row mb-2">
            <div className="col-xs-12 col-sm-10 col-md-10">
              <h1 className="text-vw-dark">MANUAL</h1>
            </div>
            <div className="col-xs-12 col-sm-2 col-md-2 align-items-center d-flex justify-content-center">
              <Link to="/manuals">
                <button className="btn btn-secondary">
                  <i className="fas fa-arrow-left mr-1"></i>Volver
                </button>
              </Link>
            </div>
          </div>
          <hr className="bg-vw-light" />
          <div className="alert alert-warning" role="alert">
            <h4 className="alert-heading">
              <i className="fas fa-exclamation-triangle mr-2"></i>
              Manual no disponible
            </h4>
            <p>El manual <strong>{manualName}</strong> no está disponible actualmente.</p>
            <hr />
            <p className="mb-0">
              <small>
                <strong>Nota:</strong> Los archivos PDF deben colocarse en la carpeta <code>public/manuals/</code> con el formato: <code>{id}.pdf</code>
              </small>
            </p>
          </div>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Información para administradores</h5>
              <p>Para añadir este manual, coloque el archivo PDF en:</p>
              <pre className="bg-light p-3 rounded">public/manuals/{id}.pdf</pre>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="row mb-2">
          <div className="col-xs-12 col-sm-8 col-md-8">
            <h1 className="text-vw-dark">MANUAL - {manualName}</h1>
          </div>
          <div className="col-xs-12 col-sm-4 col-md-4 align-items-center d-flex justify-content-end">
            <Link to="/manuals" className="mr-2">
              <button className="btn btn-secondary">
                <i className="fas fa-arrow-left mr-1"></i>Volver
              </button>
            </Link>
            <button
              className="btn bg-info text-white"
              onClick={() => window.open(pdfUrl, '_blank')}
            >
              <i className="fas fa-external-link-alt mr-1"></i>Abrir en Nueva Pestaña
            </button>
          </div>
        </div>
        <hr className="bg-vw-light" />
        {/* Embed PDF */}
        <div style={{ width: '100%', height: '80vh', backgroundColor: '#525659' }}>
          <iframe
            src={pdfUrl}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title="Manual PDF"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  error: state.audits.error,
  loading: state.audits.loading,
  form: state.form,
});

export default connect(mapStateToProps)(ManualDetailsView);
